// Complete Page - Stage 11_PROVISIONED
// Success page shown after user is provisioned, with auto-redirect to FleetVision
// UPDATED: Added demo mode support - skip auto-redirect
import { useEffect, useState } from 'react'
import { useDemoMode } from '../../hooks/useDemoMode'

const FLEETVISION_URL = 'https://fleetvision.insurevision.ai'

const CompletePage = () => {
  const [countdown, setCountdown] = useState(3)
  const { isDemoMode, exitDemo } = useDemoMode()

  useEffect(() => {
    // DEMO MODE: Skip auto-redirect
    if (isDemoMode) return

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          window.location.href = FLEETVISION_URL
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [isDemoMode])

  return (
    <div className="max-w-xl mx-auto text-center animate-fade-in">
      {/* Success Icon */}
      <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-accent-500 to-accent-600 flex items-center justify-center shadow-strong">
        <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>

      <h1 className="text-2xl font-display font-bold text-brand-950 mb-3">
        Your FleetVision Account is Ready!
      </h1>
      
      <p className="text-slate-600 mb-6">
        You've been set up with access to FleetVision. Check your email for login instructions.
      </p>

      {/* Demo mode: Exit Demo button instead of redirect */}
      {isDemoMode ? (
        <button
          onClick={exitDemo}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-purple-600 text-white font-medium rounded-lg hover:bg-purple-700 transition-colors shadow-strong"
        >
          Exit Demo
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ) : (
        <>
          <p className="text-slate-500 mb-6">
            Redirecting to FleetVision in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>

          <a
            href={FLEETVISION_URL}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-brand-600 text-white font-medium rounded-lg hover:bg-brand-700 transition-colors shadow-strong"
          >
            Go to FleetVision Now
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </>
      )}
    </div>
  )
}

export default CompletePage
